import { render, staticRenderFns } from "./MtReport.vue?vue&type=template&id=28bda7b0&scoped=true&"
import script from "./MtReport.vue?vue&type=script&lang=js&"
export * from "./MtReport.vue?vue&type=script&lang=js&"
import style0 from "./MtReport.vue?vue&type=style&index=0&id=28bda7b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bda7b0",
  null
  
)

export default component.exports